import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter, Link } from 'react-router-dom'
import ReactTable from 'react-table'
import {
  Button,
  Form,
  Modal,
  Popconfirm,
  Input,
  message,
  Tooltip,
  Upload,
  Icon,
  Pagination
} from 'antd'
import InputMask from 'react-input-mask'
import moment from 'moment'
import { actions } from '../../redux/modules/vendorsActions'
import { actions as addressActions } from '../../redux/modules/addressActions'
import { actions as contactsActions } from '../../redux/modules/contactsActions'
import { actions as jobPaymentRequestActions } from '../../redux/modules/jobFunctions/jobPaymentRequestActions'
import { actions as itemsActions } from '../../redux/modules/itemsActions'
import { actions as purchaseOrderActions } from '../../redux/modules/jobFunctions/jobSitePurchaseOrderActions'
import CreateAddressForm from '../../components/CreateAddressForm'
import PaymentRequests from '../../components/vendor/PaymentRequests'
import PurchaseOrders from '../../components/vendor/PurchaseOrders'
import ContactsQuickAdd from '../../components/ContactsQuickAdd'
import Items from '../../components/vendor/Items'
import { filterCaseInsensitive } from '../../util'
import { TextMask, SpanAdapter } from 'react-text-mask-hoc'
import PaginationComponent from '../../components/PaginationComponent'
import Notes from '../../components/notes/Notes'
import styled from 'styled-components'
import _ from 'lodash'
import SingleView from '../../components/SingleView'
import { drop } from 'lodash'

const propTypes = {}
const FormItem = Form.Item
const { TextArea } = Input

const FilesUploadContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  -webkit-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
`

const EditAttachmentContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`
const EditAttachmentTitle = styled.h6`
  color: #fff;
`
const EditingFileContainer = styled.div`
  margin: 10px 0;
`

class Vendors extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      addressFormShowing: false,
      contactFormShowing: false,
      content: null,
      addressData: null,
      currentNote: null,
      currentNoteId: null,
      currentId: +this.props.match.params.vendorId,
      addressesPage: 1,
      filesPage: 1
    }
    this.props.vendorsRefresh()
  }

  componentDidUpdate(prevProps) {
    if (
      +this.props.match.params.vendorId &&
      this.props.vendorsActions &&
      this.props.vendorsActions.payload
    ) {
      if (this.props.vendorsActions.payload && !prevProps.vendorsActions.payload) {
        if (this.props.vendorsActions.payload.data) {
          const row = _.find(
            this.props.vendorsActions.payload.data,
            vendor => vendor.id === this.state.currentId
          )

          if (row) {
            this.handleRowClick(row)
          }
        }
      }
    }
  }

  handleAddButton = () => {
    this.props.form.resetFields()
    this.setState({
      modalVisible: true,
      content: null,
      currentId: 0,
      address1Validate: true,
      cityValidate: true,
      stateValidate: true,
      zipValidate: true
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({
      data: [],
      currentId: 0,
      modalVisible: false,
      content: null,
      // close notes stuff
      currentNote: null,
      currentNoteId: null,
      noteAddEditContainer: false
    })
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      if (this.state.currentId === 0) {
        // check work number length
        let workNumber = values.work_number_add.replace(/[^0-9]+/g, '')
        if (workNumber.length < 10) {
          message.error('The Work number needs at least 10 digits.')
          return
        }
        values.name = values.name_add
        delete values.name_add
        this.props.createNewVendor({
          vendor: values,
          userId: this.props.authentication.user.userId
        })
        message.warning('Vendor created')
      } else {
        // check work number length
        let workNumber = values.work_number_edit.replace(/[^0-9]+/g, '')
        if (workNumber.length < 10) {
          message.error('The Work number needs at least 10 digits.')
          return
        }
        values.name = values.name_edit
        delete values.name_edit
        this.props.updateSavedVendor({
          companyId: this.state.currentId,
          company: values,
          userId: this.props.authentication.user.userId
        })
        message.warning('Vendor updated')
      }
      form.resetFields()
      this.setState({
        content: null,
        currentId: 0,
        modalVisible: false,
        addressFormShowing: false,
        addressData: null
      })
    })
  }

  handleRowClick = row => {
    this.setState(
      {
        modalVisible: true,
        currentId: row.id,
        content: row,
        primaryAddresId: row.address_id,
        address1Validate: false,
        cityValidate: false,
        stateValidate: false,
        zipValidate: false
      },
      () => {
        this.props.form.validateFields(['name', 'work_number'], { force: true })
      }
    )
    this.props.getCompanyAddresses({ companyId: row.id })
    this.props.getCompanyContacts({ companyId: row.id })
    this.props.getAllContacts()
    this.props.getPaymentRequestByVendorId({ vendorId: row.id })
    this.props.getVendorItems({ vendorId: row.id })
    this.props.getPurchaseOrderByOrganizationId({ organizationId: row.id })
    this.props.getVendorNote({ vendorId: row.id })
    this.props.getVendorAttachments({ vendorId: row.id })
  }

  handleAddAddressButton = () => {
    this.setState({
      addressFormShowing: true
    })
  }

  handleCreateAddressButton = addressData => {
    this.props.companyCreateAddress({
      userId: this.props.authentication.user.userId,
      address: addressData,
      companyId: this.state.currentId
    })
    this.setState({
      addressFormShowing: false,
      addressData: null
    })
  }

  /* contact things */
  handleCreateContactButton = contactData => {
    this.props.companyCreateContact({
      userId: this.props.authentication.user.userId,
      contact: contactData,
      companyId: this.state.currentId
    })
    this.props.getAllContacts()
  }

  handleCreateContactByIdButton = contactId => {
    this.props.companyCreateContactById({
      userId: this.props.authentication.user.userId,
      contactId: +contactId,
      companyId: this.state.currentId
    })
  }

  handleUpdateContactButton = contactData => {
    this.setState({
      contactFormShowing: false
    })
    this.props.companyUpdateContact({
      userId: this.props.authentication.user.userId,
      contactId: this.state.contactData.id,
      contact: contactData,
      companyId: this.state.currentId
    })
  }

  handleDeleteContact = contactId => {
    this.props.deleteCompanyContacts({
      contactId,
      companyId: this.state.currentId
    })
  }
  /* end contact things */

  handleSaveAddressButton = addressData => {
    this.props.companyUpdateAddress({
      userId: this.props.authentication.user.userId,
      addressId: this.state.addressData.id,
      address: addressData,
      companyId: this.state.currentId
    })
    this.setState({
      addressFormShowing: false,
      addressData: null
    })
  }

  handleCancelAddressButton = () => {
    this.setState({
      addressFormShowing: false,
      addressData: null
    })
  }

  handleDeleteAddress = addressId => {
    this.props.deleteCompanyAddresses({
      addressId,
      companyId: this.state.currentId
    })
  }

  handleEditAddress = addressData => {
    this.setState({ addressData: addressData, addressFormShowing: true })
  }

  handleEditContact = contactData => {
    this.setState({ contactData, contactFormShowing: true })
  }

  handleDeleteVendor = () => {
    const form = this.props.form
    this.props.deleteVendor({
      companyId: this.state.currentId
    })

    form.resetFields()
    this.setState({ content: null, currentId: 0, modalVisible: false })
  }

  handleMakePrimaryAddress = addressId => {
    this.props.updateCompanyPrimaryAddress({
      addressId: addressId,
      companyId: this.state.currentId
    })

    this.setState({
      primaryAddresId: addressId
    })
  }

  handleCancelAndRefreshList = () => {
    this.props.vendorsRefresh()

    this.setState({
      modalVisible: false,
      addressFormShowing: false,
      addressData: {},
      content: null
    })
  }

  // notes things
  handleToggleNoteEditArea = () => {
    if (this.state.currentNote) {
      this.setState({
        currentNote: null,
        currentNoteId: null,
        noteAddEditContainer: true
      })
    } else {
      this.setState({
        noteAddEditContainer: !this.state.noteAddEditContainer
      })
    }
  }

  createNote = params => {
    this.props.createVendorNote({
      content: params,
      userId: this.props.authentication.userId,
      vendorId: this.state.currentId
    })

    this.handleToggleNoteEditArea()
  }

  updateNote = params => {
    this.props.editVendorNote({
      content: params,
      noteId: this.state.currentNoteId,
      vendorId: this.state.currentId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null
    })
  }

  deleteNote = () => {
    this.props.deleteVendorNote({
      noteId: this.state.currentNoteId,
      vendorId: this.state.currentId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null,
      noteAddEditContainer: false
    })
  }

  handleRowNoteClick = row => {
    this.setState({
      noteAddEditContainer: true,
      currentNote: row,
      currentNoteId: row.id
    })
  }

  /*attachments*/
  uploadAttachment = uploadParam => {
    const formData = new FormData()

    formData.append('file', uploadParam.file)
    formData.append('type', 'job_vendor')
    formData.append('created_by_id', this.props.authentication.user.userId)
    formData.append('updated_by_id', this.props.authentication.user.userId)
    formData.append('filename', uploadParam.file.name)
    formData.append('description', uploadParam.file.name)
    formData.append('vendorId', this.state.currentId)

    this.props.uploadAttachment({
      formData: formData,
      vendorId: this.state.currentId
    })
  }

  handleAttachmentRowClick = row => {
    this.setState({
      attachmentDetailsVisible: true,
      attachmentId: row.id,
      attachmentName: row.filename,
      attachmentDescription: row.description
    })
  }

  onChangeAttachmentDescription = () => {
    this.props.updateAttachmentDescription({
      description: this.state.attachmentDescription,
      attachmentId: this.state.attachmentId,
      vendorId: this.state.currentId,
      userId: this.props.authentication.user.userId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  onDescriptionChange = e => {
    this.setState({
      attachmentDescription: e.target.value
    })
  }

  confirmAttachmentDelete = attachment => {
    this.props.deleteAttachment({
      attachmentId: attachment.id,
      vendorId: this.state.currentId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  // custom validators
  nameAddValidator = (rule, value, callback) => {
    if (!this.state.content && !value) {
      callback('Name cannot be blank.')
    } else {
      callback()
    }
  }

  workNumberAddValidator = (rule, value, callback) => {
    if (!this.state.content && !value) {
      callback('Phone Number cannot be blank.')
    } else {
      callback()
    }
  }

  setAddressesPage = addressesPage => {
    this.setState({
      addressesPage
    })
  }

  setFilesPage = filesPage => {
    this.setState({
      filesPage
    })
  }

  getAddressesData = () =>
    this.props.addressActions &&
    this.props.addressActions.payload &&
    this.props.addressActions.payload.data
      ? this.props.addressActions.payload.data
      : []

  getFilesData = () =>
    this.props.vendorsActions &&
    this.props.vendorsActions.vendorAttachments &&
    this.props.vendorsActions.vendorAttachments.data
      ? this.props.vendorsActions.vendorAttachments.data
      : []

  getAddressesPagedData = () => {
    const { addressesPage } = this.state
    const data =
      this.props.addressActions &&
      this.props.addressActions.payload &&
      this.props.addressActions.payload.data
    const offset = (addressesPage - 1) * 10
    return drop(data, offset).slice(0, 10)
  }

  getFilesPagedData = () => {
    const { filesPage } = this.state
    const data =
      this.props.vendorsActions &&
      this.props.vendorsActions.vendorAttachments &&
      this.props.vendorsActions.vendorAttachments.data
    const offset = (filesPage - 1) * 10
    return drop(data, offset).slice(0, 10)
  }

  render() {
    const { payload } = this.props.vendorsActions
    const { getFieldDecorator } = this.props.form
    const { content } = this.state
    const uploadProps = {
      multiple: true,
      fileList: this.state.fileList
    }
    const purchaseOrders = _.get(this.props, 'jobSitePurchaseOrderActions.purchaseOrders.data')

    if (!payload) {
      return (
        <div>
          <i className="fa fa-refresh fa-spin fa-3x fa-fw" />
          <span className="sr-only">Loading...</span>
        </div>
      )
    } else {
      return (
        <div>
          <Modal
            visible={this.state.modalVisible}
            title="Vendor"
            okText={content ? 'Save Changes' : 'Create'}
            onCancel={this.handleCancelAndRefreshList}
            onOk={this.handleCreate}
            width={content ? '90%' : 800}
            maskClosable={false}
          >
            <Form layout="vertical">
              {!content && (
                <div>
                  <div className="row">
                    <div className="col-md-6">
                      <FormItem label="Name">
                        {getFieldDecorator('name_add', {
                          rules: [
                            {
                              required: false
                            },
                            {
                              validator: this.nameAddValidator
                            }
                          ],
                          initialValue: content ? content.name : ''
                        })(<Input placeholder="Type the company name..." />)}
                      </FormItem>
                    </div>
                    <div className="col-md-6">
                      <FormItem label="Phone Number">
                        {getFieldDecorator('work_number_add', {
                          rules: [
                            {
                              required: false
                            },
                            {
                              validator: this.workNumberAddValidator
                            }
                          ],
                          initialValue: ''
                        })(
                          <InputMask
                            className="ant-input"
                            mask="(999) 999-9999 ext:9999"
                            maskChar="_"
                          />
                        )}
                      </FormItem>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <FormItem label="FAX Number">
                        {getFieldDecorator('fax_number', {
                          initialValue: ''
                        })(<Input placeholder="Type in fax number..." />)}
                      </FormItem>
                    </div>
                    <div className="col-md-6">
                      <FormItem label="Street Address">
                        {getFieldDecorator('address1', {
                          rules: [
                            {
                              required: this.state.address1Validate,
                              message: 'Street Address cannot be blank.'
                            }
                          ],
                          initialValue: ''
                        })(<Input />)}
                      </FormItem>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <FormItem label="Apt/Suite/Floor">
                        {getFieldDecorator('address2', {
                          initialValue: ''
                        })(<Input />)}
                      </FormItem>
                    </div>
                    <div className="col-md-6">
                      <FormItem label="City">
                        {getFieldDecorator('city', {
                          rules: [
                            {
                              required: this.state.cityValidate,
                              message: 'City cannot be blank.'
                            }
                          ],
                          initialValue: ''
                        })(<Input />)}
                      </FormItem>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <FormItem label="State">
                        {getFieldDecorator('state', {
                          rules: [
                            {
                              required: this.state.stateValidate,
                              message: 'State cannot be blank.'
                            }
                          ],
                          initialValue: ''
                        })(<Input />)}
                      </FormItem>
                    </div>
                    <div className="col-md-6">
                      <FormItem label="Zip">
                        {getFieldDecorator('zip', {
                          rules: [
                            {
                              required: this.state.zipValidate,
                              message: 'ZIP cannot be blank.'
                            }
                          ],
                          initialValue: ''
                        })(<Input type="number" />)}
                      </FormItem>
                    </div>
                  </div>
                </div>
              )}
              {content && (
                <div>
                  <div className="row">
                    <div className="col-md-6">
                      <FormItem label="Name">
                        {getFieldDecorator('name_edit', {
                          rules: [
                            {
                              required: true,
                              message: 'Name cannot be blank.'
                            }
                          ],
                          initialValue: content.name
                        })(<Input placeholder="Type the company name..." />)}
                      </FormItem>
                    </div>
                    <div className="col-md-6">
                      <div className="row" style={{ marginBottom: '15px', marginTop: '15px' }}>
                        <div className="col-md-3">
                          Created by:<br />
                          <strong>{` ${content.created_by_first_name} ${
                            content.created_by_last_name
                          }`}</strong>
                        </div>
                        <div className="col-md-3">
                          Updated by:<br />
                          <strong>{` ${content.updated_by_first_name} ${
                            content.updated_by_last_name
                          }`}</strong>
                        </div>
                        <div className="col-md-3">
                          Created date:<br />
                          <strong>{moment.utc(content.created_date).format('M/D/YYYY')}</strong>
                        </div>
                        <div className="col-md-3">
                          Updated date:<br />
                          <strong>{moment.utc(content.updated_date).format('M/D/YYYY')}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <FormItem label="Work Number">
                        {getFieldDecorator('work_number_edit', {
                          initialValue: content ? content.work_number : ''
                        })(
                          <InputMask
                            className="ant-input"
                            mask="(999) 999-9999 ext:9999"
                            maskChar="_"
                          />
                        )}
                      </FormItem>
                    </div>
                    <div className="col-md-6">
                      <FormItem label="FAX Number">
                        {getFieldDecorator('fax_number', {
                          initialValue: content ? content.fax_number : 'Client'
                        })(
                          <InputMask
                            className="ant-input"
                            mask="(999) 999-9999 ext:9999"
                            maskChar="_"
                          />
                        )}
                      </FormItem>
                    </div>
                  </div>
                </div>
              )}
            </Form>
            {content && (
              <div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="">
                      <div className="jobsBar">
                        Addresses
                        {!this.state.addressFormShowing && (
                          <div className="jobsBarAdd" onClick={() => this.handleAddAddressButton()}>
                            <i className="fa fa-pencil-square" aria-hidden="true" />
                            &nbsp;<div className="addJobLabel">ADD ADDRESS</div>
                          </div>
                        )}
                        {this.state.addressFormShowing && (
                          <div className="displayFlex">
                            <div
                              className="jobsBarAdd"
                              onClick={() => this.handleCancelAddressButton()}
                            >
                              <i className="fa fa-ban" aria-hidden="true" />
                              &nbsp;<div className="addJobLabel">CANCEL</div>
                            </div>
                          </div>
                        )}
                      </div>
                      {this.state.addressFormShowing && (
                        <CreateAddressForm
                          addAddress={this.handleCreateAddressButton}
                          saveAddress={this.handleSaveAddressButton}
                          contentData={this.state.addressData}
                        />
                      )}
                      {!this.state.addressFormShowing && (
                        <div>
                          <SingleView
                            title="Addresses"
                            emptyText="No addresses for this vendor"
                            data={this.getAddressesPagedData()}
                            getKey={a => a.id}
                            getHeader={a => a.address1}
                          >
                            {a => (
                              <div className="row">
                                <div className="col-md-9">
                                  <div className="jobDetailsHeader">Content:</div>
                                  <span>
                                    {a.company} {a.name} {a.address1} {a.address2} {a.city}{' '}
                                    {a.state} {a.zip}
                                  </span>
                                </div>
                                <div className="col-md-3">
                                  <Popconfirm
                                    title="Are you sure you want to make this the primary address for this company?"
                                    onConfirm={() => this.handleMakePrimaryAddress(a.id)}
                                    onCancel={this.cancelDelete}
                                    okText="Yes"
                                    cancelText="No"
                                  >
                                    <Button
                                      size="small"
                                      icon={this.state.primaryAddresId === a.id ? 'star' : 'star-o'}
                                      type="link"
                                      style={{ color: '#1F45B4' }}
                                    />
                                  </Popconfirm>
                                  <Button
                                    size="small"
                                    className="marginLeft5"
                                    icon="edit"
                                    onClick={() => this.handleEditAddress(a)}
                                  />
                                  <Popconfirm
                                    title="Are you sure you want to delete this line?"
                                    onConfirm={() => this.handleDeleteAddress(a.id)}
                                    onCancel={this.cancelDelete}
                                    okText="Yes"
                                    cancelText="No"
                                  >
                                    <Button
                                      size="small"
                                      className="marginLeft5"
                                      type="danger"
                                      icon="delete"
                                    />
                                  </Popconfirm>
                                </div>
                              </div>
                            )}
                          </SingleView>
                          <Pagination
                            total={this.getAddressesData().length}
                            pageSize={10}
                            current={this.state.addressesPage}
                            defaultCurrent={1}
                            onChange={this.setAddressesPage}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <ContactsQuickAdd
                      handleCreateContactButton={this.handleCreateContactButton}
                      handleUpdateContactButton={this.handleUpdateContactButton}
                      handleCreateContactByIdButton={this.handleCreateContactByIdButton}
                      handleDeleteContact={this.handleDeleteContact}
                      companyContacts={
                        this.props.contactsActions &&
                        this.props.contactsActions.companyContacts &&
                        this.props.contactsActions.companyContacts.data
                      }
                      allContacts={
                        this.props.contactsActions &&
                        this.props.contactsActions.allContacts &&
                        this.props.contactsActions.allContacts.data
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <PaymentRequests
                      paymentRequests={
                        this.props.jobPaymentRequestActions &&
                        this.props.jobPaymentRequestActions.paymentRequests &&
                        this.props.jobPaymentRequestActions.paymentRequests.data
                      }
                    />
                  </div>
                  <div className="col-6">
                    <Items
                      Items={
                        this.props.itemsActions &&
                        this.props.itemsActions.vendorItems &&
                        this.props.itemsActions.vendorItems.data
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <PurchaseOrders purchaseOrders={purchaseOrders} />
                  </div>
                  <div className="col-6">
                    <Notes
                      // notes props
                      currentNote={this.state.currentNote}
                      currentNoteId={this.state.currentNoteId}
                      notes={
                        this.props.vendorsActions.vendorNotes &&
                        this.props.vendorsActions.vendorNotes.data
                      }
                      handleToggleNoteEditArea={this.handleToggleNoteEditArea}
                      noteAddEditContainer={this.state.noteAddEditContainer}
                      createNote={this.createNote}
                      handleRowNoteClick={this.handleRowNoteClick}
                      updateNote={this.updateNote}
                      userId={this.props.authentication.user.userId}
                      deleteNote={this.deleteNote}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <FilesUploadContainer>
                      <div className="row">
                        <div className="col-md-6">
                          <h6>
                            <Icon type="file" /> Vendor Files
                          </h6>
                        </div>
                        <div className="col-md-6 text-right">
                          {this.props.vendorsActions &&
                            this.props.vendorsActions.uploadingAttachment && (
                              <div className="text-success">
                                <Icon type="loading" /> Uploading File(s)
                              </div>
                            )}
                          {this.props.vendorsActions &&
                            this.props.vendorsActions.deletingAttachment && (
                              <div className="text-danger">
                                <Icon type="loading" /> Deleting File(s)
                              </div>
                            )}
                        </div>
                      </div>
                      {this.props.vendorsActions.vendorAttachments &&
                        this.props.vendorsActions.vendorAttachments.data.length > 0 && (
                          <div>
                            <SingleView
                              emptyText="No attachments for this vendor"
                              data={this.getFilesPagedData()}
                              getKey={c => c.id}
                              getHeader={c => c.filename}
                            >
                              {a => (
                                <Fragment>
                                  <div className="row">
                                    <div className="col-md-5">
                                      <div className="jobDetailsHeader">Name:</div>
                                      <span>{a.filename}</span>
                                    </div>
                                    <div className="col-md-5">
                                      <div className="jobDetailsHeader">Description:</div>
                                      <span>{a.description}</span>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-md-5">
                                      <div className="jobDetailsHeader">Created By:</div>
                                      <span>
                                        {a.created_by_first_name} {a.created_by_last_name}
                                      </span>
                                    </div>
                                    <div className="col-md-5">
                                      <div className="jobDetailsHeader">Updated by:</div>
                                      <span>
                                        {a.updated_by_first_name} {a.updated_by_last_name}
                                      </span>
                                    </div>
                                    <div className="col-md-1">
                                      <Tooltip
                                        placement="left"
                                        title="Open this file on a new window"
                                      >
                                        <a target="_blank" href={a.signedUrl}>
                                          <Icon type="export" className="fontSize20" />
                                        </a>
                                      </Tooltip>
                                    </div>
                                    <div className="col-md-1">
                                      <Popconfirm
                                        title="Are you sure you want to delete this attachment?"
                                        onConfirm={() => {
                                          this.confirmAttachmentDelete(a)
                                        }}
                                        okText="Yes"
                                        cancelText="No"
                                      >
                                        <Button type="danger" icon="delete" className="ml-2" />
                                      </Popconfirm>
                                    </div>
                                  </div>
                                </Fragment>
                              )}
                            </SingleView>
                            <Pagination
                              total={this.getFilesData().length}
                              pageSize={10}
                              current={this.state.filesPage}
                              defaultCurrent={1}
                              onChange={this.setFilesPage}
                            />
                          </div>
                        )}
                      {this.state.attachmentDetailsVisible && (
                        <EditAttachmentContainer>
                          <EditAttachmentTitle>
                            <Icon type="edit" /> Edit Attachment Area
                          </EditAttachmentTitle>
                          <div>
                            <EditingFileContainer>
                              <Icon type="file" /> {this.state.attachmentName}
                            </EditingFileContainer>
                          </div>
                          <div className="row">
                            <div className="col-md-10">
                              <TextArea
                                placeholder="Describe the attachment..."
                                rows={4}
                                onChange={this.onDescriptionChange}
                                value={this.state.attachmentDescription}
                              />
                            </div>
                          </div>
                          <div className="d-flex flex-row mt-2">
                            <Button onClick={this.onChangeAttachmentDescription}>
                              <Icon type="save" /> OK
                            </Button>{' '}
                            <Popconfirm
                              title="Are you sure you want to delete this attachment?"
                              onConfirm={this.confirmAttachmentDelete}
                              okText="Yes"
                              cancelText="No"
                            >
                              <Button type="danger" icon="delete" className="ml-2">
                                {' '}
                                DELETE
                              </Button>
                            </Popconfirm>
                          </div>
                        </EditAttachmentContainer>
                      )}
                      <br />
                      <div>Upload AIA File(s)</div>
                      <br />
                      <Upload {...uploadProps} name="file" customRequest={this.uploadAttachment}>
                        <Button>
                          <Icon type="upload" /> Upload
                        </Button>
                      </Upload>
                    </FilesUploadContainer>
                  </div>
                </div>
              </div>
            )}
            <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={this.handleDeleteVendor}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              {content && <Button type="danger" icon="delete" />}
            </Popconfirm>
          </Modal>
          <div className="dataHeader">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/vendors">Vendors</Link>
                </li>
              </ol>
            </nav>
            <h2>Vendors</h2>
          </div>
          <div className="dataPanel">
            <div className="wrapPanel">
              <div className="jobsBar">
                Vendors
                <div className="jobsBarAdd">
                  <i className="fa fa-plus-square" aria-hidden="true" />
                  &nbsp;
                  <div className="addJobLabel" onClick={() => this.handleAddButton()}>
                    NEW VENDOR
                  </div>
                </div>
              </div>
              <ReactTable
                data={payload.data}
                getTdProps={(state, rowInfo, column, instance) => ({
                  onClick: e => {
                    if (column.Header !== undefined) {
                      this.handleRowClick(rowInfo.original)
                    }
                  }
                })}
                defaultSorted={[
                  {
                    id: 'created_date',
                    desc: true
                  }
                ]}
                filterable
                defaultFilterMethod={filterCaseInsensitive}
                PaginationComponent={PaginationComponent}
                columns={[
                  {
                    columns: [
                      {
                        Header: 'Name',
                        id: 'name',
                        accessor: 'name',
                        Cell: d => <Tooltip title={d.original.name}>{d.original.name}</Tooltip>
                      },
                      {
                        Header: 'Phone Number',
                        accessor: 'work_number',
                        minWidth: 60,
                        Cell: d => (
                          <TextMask
                            Component={SpanAdapter}
                            value={d.original.work_number}
                            mask={[
                              '(',
                              /[1-9]/,
                              /\d/,
                              /\d/,
                              ')',
                              ' ',
                              /\d/,
                              /\d/,
                              /\d/,
                              '-',
                              /\d/,
                              /\d/,
                              /\d/,
                              /\d/
                            ]}
                            guide
                          />
                        )
                      },
                      {
                        Header: 'Fax Number',
                        accessor: 'fax_number',
                        minWidth: 60,
                        Cell: d => (
                          <TextMask
                            Component={SpanAdapter}
                            value={d.original.fax_number}
                            mask={[
                              '(',
                              /[1-9]/,
                              /\d/,
                              /\d/,
                              ')',
                              ' ',
                              /\d/,
                              /\d/,
                              /\d/,
                              '-',
                              /\d/,
                              /\d/,
                              /\d/,
                              /\d/
                            ]}
                            guide
                          />
                        )
                      },
                      {
                        Header: 'Address',
                        id: 'address',
                        accessor: d =>
                          `${d.address1 !== null && d.address1}${
                            d.address2 !== null ? ' ' + d.address2 : ''
                          }${d.city !== null ? ', ' + d.city : ''}${
                            d.state !== null ? ' - ' + d.state : ''
                          }${d.zip !== null ? ' - ' + d.zip : ''}`,
                        minWidth: 120,
                        Cell: d => {
                          const r = `${d.original.address1 !== null && d.original.address1}${
                            d.original.address2 !== null ? ' ' + d.original.address2 : ''
                          }${d.original.city !== null ? ', ' + d.original.city : ''}${
                            d.original.state !== null ? ' - ' + d.original.state : ''
                          }${d.original.zip !== null ? ' - ' + d.original.zip : ''}`
                          return <Tooltip title={r}>{r}</Tooltip>
                        }
                      },
                      {
                        Header: 'Created Date',
                        id: 'created_date',
                        accessor: 'created_date',
                        minWidth: 60,
                        Cell: d => moment.utc(d.original.created_date).format('M/D/YYYY')
                      }
                    ]
                  }
                ]}
                defaultPageSize={10}
                className="-striped -highlight"
              />
              <br />
              &copy; 2018 G-Tech Elevator Associates LLC
            </div>
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = (
  {
    addressActions,
    contactsActions,
    vendorsActions,
    authentication,
    jobPaymentRequestActions,
    itemsActions,
    jobSitePurchaseOrderActions
  },
  ownProps
) => ({
  addressActions,
  contactsActions,
  vendorsActions,
  authentication,
  jobPaymentRequestActions,
  itemsActions,
  jobSitePurchaseOrderActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign(
      {},
      actions,
      addressActions,
      contactsActions,
      jobPaymentRequestActions,
      itemsActions,
      purchaseOrderActions
    ),
    dispatch
  )
})

Vendors.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(Vendors)))



// WEBPACK FOOTER //
// ./src/containers/vendors/index.js